<template>
    <div class="ah-receipt-item">
        <div class="file">
            <div v-if="['jpeg', 'jpg', 'png'].includes(getFileExtByUrl(data.filE_ATT))" class="img-rect">
                <el-image style="width: 100%" :src="data.filE_ATT" :previewSrcList="[data.filE_ATT]" v-if="data.filE_ATT"></el-image>
            </div>
            <div v-else-if="data.filE_ATT" class="file-rect">
                <ahFileIcon ext="pdf" :url="data.filE_ATT" />
            </div>
            <div v-else class="no-file-rect">
                <span style="color: #aaa; cursor: default">未上傳</span>
            </div>
        </div>
        <div class="infos">
            <div class="type-name">{{ fileTypNumToName(data.filE_TYP) }}</div>
            <div class="columns">
                <div class="column">
                    <div class="label">單據日期</div>
                    <div class="value">{{ data.foO_DAT | dateFormater("YYYY-MM-dd") }}</div>
                </div>
                <div class="column" v-if="[1, 2, 3, 10].includes(data.filE_TYP)">
                    <div class="label">發票號碼</div>
                    <div class="value">
                        <div><ahReceiptNumber :v="data.foo" /> <i v-if="isCheckingInvoice" class="el-icon-loading" /></div>
                        <template v-if="!isCheckingInvoice">
                            <div v-if="isInvoiceUsed" class="invoice-used-msg"><i class="el-icon-warning" /> 注意：此發票號碼已存在於請款單： {{ isInvoiceUsed }}</div>
                            <div v-else-if="isInvoiceUsedBySelf" class="invoice-used-msg"><i class="el-icon-warning" /> 注意：此發票號碼已存在於本請款單</div>
                        </template>
                    </div>
                </div>
                <div class="column" v-else-if="data.filE_TYP === 11">
                    <div class="label">票根號碼</div>
                    <div class="value">
                        <div>{{ data.foo }} <i v-if="isCheckingInvoice" class="el-icon-loading" /></div>
                        <template v-if="!isCheckingInvoice">
                            <div v-if="isInvoiceUsed" class="invoice-used-msg"><i class="el-icon-warning" /> 注意：此發票號碼已存在於請款單： {{ isInvoiceUsed }}</div>
                            <div v-else-if="isInvoiceUsedBySelf" class="invoice-used-msg"><i class="el-icon-warning" /> 注意：此發票號碼已存在於本請款單</div>
                        </template>
                    </div>
                </div>
                <div class="column">
                    <div class="label">公司名稱</div>
                    <div class="value">{{ data.companyName }}</div>
                </div>
                <div class="column" v-if="[1, 2, 3, 4, 10, 11].includes(data.filE_TYP)">
                    <div class="label">統編</div>
                    <div class="value">{{ data.bsn }}</div>
                </div>
                <div class="column" v-if="[1, 2, 3, 4, 6, 7, 10, 11].includes(data.filE_TYP)">
                    <div class="label">單據總額</div>
                    <div class="value"><Money :v="data.amt" /> {{ cny }}</div>
                </div>
                <div class="column" v-if="[1, 2, 3, 10, 11].includes(data.filE_TYP)">
                    <div class="label">營業稅<ahTip>5%</ahTip></div>
                    <div class="value"><Money :v="data.tax" /> {{ cny }}</div>
                </div>
                <div class="column" v-if="[1, 2, 3, 10, 11].includes(data.filE_TYP)">
                    <div class="label">銷售額(未稅)</div>
                    <div class="value"><Money :v="data.amt - data.tax" /> {{ cny }}</div>
                </div>
                <div class="column">
                    <div class="label">上傳日期</div>
                    <div class="value">
                        <el-tooltip class="item" effect="dark" :content="formateTimestamp(data.crT_DAT)" placement="top">
                            <span>{{ data.crT_DAT | dateFormater("YYYY-MM-dd") }}</span>
                        </el-tooltip>
                    </div>
                </div>
                <div class="column" v-if="data.note">
                    <div class="label">備註</div>
                    <div class="value" style="white-space: pre-wrap">{{ data.note }}</div>
                </div>
                <div v-if="isShowTaxStatus && [1, 2, 3, 10, 11].includes(data.filE_TYP)" class="column">
                    <div class="label">營業稅申報</div>
                    <div class="value">
                        <div v-if="data.declareStatus === 1">
                            <el-tag type="success" size="small"><i class="el-icon-check"></i> 已申報 {{ getPeriodText(data.prefiX_YER, data.prefiX_MONTH) }}</el-tag>
                        </div>
                        <div v-if="data.declareStatus === 0 || data.declareStatus === 2">
                            <div v-if="isAuthOne(['A02', 'A03'])">
                                <el-switch v-model="declareStatus" active-text="申報扣抵" :active-value="0" inactive-text="不申報" :inactive-value="2" @change="onDeclareStatusChange"> </el-switch>
                            </div>
                            <div v-else style="font-size: 10pt">
                                <div v-if="data.declareStatus === 0">申報扣抵</div>
                                <div v-if="data.declareStatus === 2">不申報</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div style="text-align: right; margin-top: 8px" v-if="editable">
                <div v-if="data.declareStatus === 1">
                    <el-tooltip class="item" effect="dark" content="此單據已申報，不可編輯、刪除。" placement="top">
                        <div style="display: inline-block">
                            <el-button size="small" disabled>編輯</el-button>
                            <el-button size="small" disabled>刪除</el-button>
                        </div>
                    </el-tooltip>
                </div>
                <div v-else>
                    <el-button size="small" @click="handleFileEditBtnClick(data)">編輯</el-button>
                    <el-button size="small" @click="handleFileDeleteBtnClick(data)">刪除</el-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment';
import _ from 'lodash';
import ahFileIcon from '@/components/ui/ahFileIcon.vue';
import { attachmentTypes } from '@/assets/commonData/options';
import ahReceiptNumber from '@/components/ui/ahReceiptNumber.vue';

export default {
    name: 'ah-receipt-data',
    components: {
        ahFileIcon,
        ahReceiptNumber,
    },
    props: {
        editable: {
            type: Boolean,
            default: false,
        },
        cny: {
            type: String,
            default: 'TWD',
        },
        isShowTaxStatus: {
            type: Boolean,
            default: true,
        },
        data: {
            type: Object,
            default() {
                return {
                    sno: null,
                    foo: '', // 發票號碼
                    foO_DAT: null, // 發票日期
                    bsn: '', // 統一編號
                    filE_ATT: '', // 檔案
                    filE_TYP: null, // 檢附單據類型
                    companyName: '', // 公司名稱
                    tax: 0, // 發票營業稅稅
                    amt: 0,
                    note: '', // 備註
                };
            },
        },
        allReceipt: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        isDeclareDatePassed() {
            const RECEIPT_MONTH = moment(this.data.foO_DAT).month() + 1;

            let year = moment(this.data.foO_DAT).year();
            const PERIOD = Math.ceil(RECEIPT_MONTH / 2);
            const RECEIPT_DECLARE_MONTH = ((PERIOD + 1) * 2 - 1) % 12;
            const RECEIPT_DECLARE_YEAR = ((PERIOD + 1) * 2 - 1) / 12 + year;
            if (RECEIPT_MONTH > 10) year += 1;

            const DUE_DATE = moment()
                .year(RECEIPT_DECLARE_YEAR)
                .month(RECEIPT_DECLARE_MONTH - 1)
                .date(15)
                .startOf('day');

            return moment().isAfter(DUE_DATE);
        },
    },
    data() {
        return {
            declareStatus: this.data ? this.data.declareStatus : 0,
            isCheckingInvoice: false,
            isInvoiceUsed: false,
            isInvoiceUsedBySelf: false,
        };
    },
    mounted() {
        this.onCheckValidateInvoice();
    },
    methods: {
        fileTypNumToName(num) {
            const type = attachmentTypes.find((x) => x.key == num);
            if (type) return type.value;
            return '';
        },
        getFileExtByUrl(url) {
            if (url) {
                return url.split('.').pop().toLowerCase();
            }
            return null;
        },
        handleFileEditBtnClick(data) {
            this.$emit('edit', data);
        },
        handleFileDeleteBtnClick(data) {
            this.$emit('delete', data);
        },
        async onDeclareStatusChange(val) {
            try {
                if (this.isDeclareDatePassed && val === 0) {
                    await this.$confirm('已過該發票申報期限，請確認是否重新列爲該期可扣抵進項稅額單據？', {
                        confirmButtonText: '確定',
                        cancelButtonText: '取消',
                    });
                }
                this.$emit('declareStatusChange', { receiptSno: this.data.sno, declareStatus: val });
            } catch (e) {
                console.log(e);
                this.declareStatus = this.data.declareStatus; // 恢復原狀態
            }
        },
        getPeriodText(year, month) {
            const monthList = ['1~2月', '3~4月', '5~6月', '7~8月', '9~10月', '11~12月'];
            if (year > 1911 && month >= 0 && month < 12) {
                return `${year - 1911}年 ${monthList[month - 1]}`;
            }
            return '';
        },
        async onCheckValidateInvoice() {
            if (!this.data.foo) return;
            try {
                this.isCheckingInvoice = true;
                const resp = await this.$api({
                    url: '/PaymentManagenmentPage/QueryReciptFile',
                    params: {
                        foo: this.data.foo,
                        year: moment(this.data.foO_DAT).year(),
                    },
                    method: 'GET',
                });

                // 檢查不包含本請款單之其他請款單
                const exceptThisList = [...resp.data.items];

                this.allReceipt.forEach((item) => {
                    const FOUND = resp.data.items.findIndex((o) => o.sno === item.sno);
                    if (FOUND >= 0) exceptThisList.splice(FOUND, 1);
                });
                this.isInvoiceUsed = _.chain(exceptThisList).map('payoo').uniq().value()
                    .join('、');

                // 檢查本請款單
                const thisList = _.chain(this.allReceipt)
                    .filter((o) => o.sno !== this.data.sno)
                    .find((o) => o.foo === this.data.foo)
                    .value();
                this.isInvoiceUsedBySelf = !!thisList;
            } finally {
                this.isCheckingInvoice = false;
            }
        },
        formateTimestamp(timestemp) {
            return moment(timestemp).format('YYYY年MM月DD日 HH:mm');
        },
    },
};
</script>

<style lang="scss" scoped>
.invoice-used-msg {
    margin: 0px 0 6px 0;
    line-height: 1;
    font-size: 9pt;
    color: red;
}
</style>

<style lang="scss">
.ah-receipt-item {
    display: block;
    width: 100%;
    margin-top: 10px;
    border-radius: 8px;
    border: 2px solid #eee;

    @media (min-width: 992px) {
        display: grid;
        grid-template-columns: 310px auto;
    }

    > .file {
        display: block;
        vertical-align: top;
        padding: 20px;
        width: 290px;

        @media (min-width: 992px) {
            // display: table-cell;
            // width: 400px;
        }

        > .img-rect,
        > .file-rect,
        > .no-file-rect {
            width: 250px;
            height: 165px;
            border: 2px solid #ddd;
            background-color: #fff;
            border-radius: 6px;
            transition: border-color 0.2s;

            &:hover {
                border: 2px solid #bbb;
            }

            .el-image {
                img {
                    width: calc(250px - 6px);
                    height: calc(165px - 6px);
                    object-fit: contain;
                }
            }

            .ah-file-icon {
                margin-top: 38px;
            }
        }
        > .no-file-rect {
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    > .infos {
        display: block;
        vertical-align: top;
        line-height: 200%;
        padding: 0 20px 20px 20px;

        @media (min-width: 992px) {
            padding: 20px 20px 20px 30px;
        }

        .type-name {
            font-weight: bold;
            margin-bottom: 10px;
        }

        > .columns {
            display: table;
            width: 100%;

            > .column {
                display: table-row;

                > .label {
                    display: table-cell;
                    text-align: left;
                    width: 100px;
                    color: #666;
                }

                > .value {
                    display: table-cell;
                    padding: 0 0 0 5px;
                    color: #000;
                }
            }
        }
    }
}
</style>
